// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"XS","product":"YS","products":"ZS","tooltipWrapper":"_S","tooltip":"aT","title":"bT"};